import defaultWallpaper from '../../ft-vue-core/images/logo-dark.svg'

export default {
  data () {
    return {
      showWallpaper: true
    }
  },
  computed: {
    wallpaperImgUrl () {
      return this.$ftAC.theme.wallpaper || defaultWallpaper
    },
    wallpaperSizing () {
      const wallpaperSizing = this.$ftAC.theme.wallpaperSizing
      switch (wallpaperSizing) {
      case '_contain30w':
        return '30%'
      case '_contain50w':
        return '50%'
      case '_contain50h':
        return 'auto 50%'
      case '_contain80h':
        return 'auto 80%'
      default:
        return  wallpaperSizing || 'contain'
      }
    },
    wallpaperStyles () {
      return [
        ...this.showWallpaper ? [{
          'background-image': `url(${this.wallpaperImgUrl})`,
          'background-color': this.$ftAC.theme.wallpaperColor
        }] : [],
        {
          'background-repeat': 'no-repeat',
          'background-size': this.wallpaperSizing,
          'background-position': 'center',
          'transition': 'background 0.2s ease-in-out'
        }
      ]
    }
  }
}
